import { IonButtons, IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory } from 'react-router';

import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';
import { IconRotate } from '@/components/Icon/types';
// Styles
import styles from '@/components/PageTopBar/PageTopBar.module.css';

import { mergeClassNames } from '@/utils';

// Types
import type { ComponentProps, PropsWithChildren } from 'react';

interface PageTopBarProps extends ComponentProps<typeof IonHeader> {
  backTarget?: string;
  variant?: 'simple' | 'detailed';
  title: string;
  description?: string;
}

export const PageTopBar = ({
  children,
  title,
  description,
  backTarget,
  ...props
}: PropsWithChildren<PageTopBarProps>) => {
  const history = useHistory();

  const goBack = (backTarget: string) => {
    history.push(backTarget);
  };

  return (
    <IonHeader className={mergeClassNames('ion-no-padding', styles.header)} {...props}>
      <IonToolbar className={styles.toolbar}>
        {backTarget && (
          <IonButtons slot='start'>
            <Button className={styles.backButton} onClick={() => goBack(backTarget)} variant='tertiary'>
              <Icon direction={IconRotate.West} name='chevron' size={13} />
              Back
            </Button>
          </IonButtons>
        )}
        {children ?? (
          <IonTitle className={styles.titleContainer}>
            <span className={styles.title} style={{ marginRight: '4px' }}>
              {title}
            </span>

            {description && (
              <>
                <span className={styles.seperator}> | </span>
                <span className={styles.description} style={{ marginLeft: '4px' }}>
                  {description}
                </span>
              </>
            )}
          </IonTitle>
        )}
      </IonToolbar>
    </IonHeader>
  );
};
